import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Container(theme: Theme) {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4)
        }
      }
    }
  };
}
